import { inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ConfirmationMessageModalComponent,
  IModalParameters,
} from 'src/app/shared/modals/confirmation-message-modal/confirmation-message-modal.component';

@Injectable({
  providedIn: 'root',
})
export class LicensePopupService {
  private readonly modalService = inject(NgbModal);
  private readonly moduleVideoUrls: Readonly<Record<string, string>> = {
    historie: 'https://hoppenbrouwers.blob.core.windows.net/energyportal/assets/moduleMedia/historie.mp4',
    milieu: 'https://hoppenbrouwers.blob.core.windows.net/energyportal/assets/moduleMedia/milieu.mp4',
    klimaat: 'https://hoppenbrouwers.blob.core.windows.net/energyportal/assets/moduleMedia/klimaat.mp4',
  };
  private readonly moduleDescriptions: Readonly<Record<string, readonly string[]>> = {
    klimaat: [
      'Met de Klimaatmodule krijg je inzicht in het binnenklimaat van je gebouwen. Je kunt temperaturen, luchtvochtigheid, CO₂-concentraties en andere klimaatwaarden monitoren en analyseren.',
      'De module helpt je om comfortklachten te verminderen, installaties beter af te stemmen en afwijkingen sneller te signaleren. Hierdoor creëer je een prettigere en gezondere omgeving voor gebruikers van het gebouw.',
      'Deze module is vooral interessant voor organisaties die actief sturen op comfort, gezondheid, energieprestaties en het optimaal functioneren van klimaatinstallaties.',
    ],
    milieu: [
      'Met de Milieumodule krijg je inzicht in de milieuprestaties van je vastgoedportefeuille. De module helpt je bij het monitoren van energieverbruik, CO₂-uitstoot, hernieuwbare energie en andere duurzaamheidsindicatoren.',
      'Daarnaast ondersteunt de module bij rapportages voor duurzaamheidsdoelstellingen en wet- en regelgeving, zoals CSRD. Zo krijg je beter inzicht in waar verbeteringen mogelijk zijn en welke locaties extra aandacht nodig hebben.',
      'Deze module is vooral interessant voor organisaties die actief bezig zijn met verduurzaming, ESG-doelstellingen, CO₂-reductie en duurzaamheidsrapportages.',
    ],
    historie: [
      'Met de Historiemodule kun je meetgegevens tot in detail analyseren. Je krijgt toegang tot historische verbruiken, vermogens, meterstanden en andere meetwaarden van gebouwen, installaties en meters.',
      'Met flexibele periode-selecties, grafieken en tabellen kun je trends ontdekken, afwijkingen onderzoeken en analyses uitvoeren op specifieke assets of meetpunten.',
      'Deze module is vooral interessant voor organisaties die dieper in hun data willen duiken, energievraagstukken willen onderzoeken of onderbouwde analyses willen maken voor optimalisatie en rapportages.',
    ],
  };

  public open(moduleName: string): void {
    const normalizedModuleName = moduleName.toLowerCase();
    const description = this.moduleDescriptions[normalizedModuleName];
    const url = new URL('https://www.hoppenbrouwerstechniek.nl/energiemanager/');
    url.searchParams.set('utm_source', 'energieportaal');
    url.searchParams.set('utm_content', 'inactive_module');
    url.searchParams.set('module', normalizedModuleName);

    const parameters: IModalParameters = {
      title: 'Oeps, deze module is nog niet actief',
      message: `De module '${moduleName}' is niet beschikbaar binnen uw huidige licentie.`,
      messageParagraphs: description,
      moreInfoMessage: `Bekijk de mogelijkheden en voordelen van de ${moduleName}module op onze website`,
      videoUrl: this.moduleVideoUrls[normalizedModuleName],
      confirmButtonText: 'Ga naar website',
      confirmButtonUrl: url.toString(),
      showCancelButton: false,
    };

    const modalRef = this.modalService.open(ConfirmationMessageModalComponent, { centered: true });
    modalRef.componentInstance.parameters = parameters;
  }
}
